import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { logout } from "../../Redux/Auth/Auth.action";
import { set_active_tab } from "../../Redux/Tab/Tab.action";
import "./sidebar.css";
import { Tooltip, Position, StandardSizes } from "evergreen-ui";
import { ModalLogout } from "./ModalLogout";
import { IMAGE_PATH, SUB_LOGO } from "../../Utils/variables";
const Sidebar = ({ RenderHandler }) => {
  const { active } = useSelector((state) => state.activeTabCheck);

  // ---------------states for modal----------------------
  const [disablebtn, setDisableBtn] = useState(false);
  const [Theme, setTheme] = useState(process.env.REACT_APP_PRODUCT);
  const [open, setOpen] = useState(false);
  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);
  const handleDisablebtn = () => setDisableBtn(true);

  const handleSubmit = () => {
    dispatch(logout());
    localStorage.clear();
    navigate("/login");
  };

  const navigate = useNavigate();
  const sidebarArray = [
    // {
    //   id: 1,
    //   svg: "./images/stratum/dashboardLogosimple.svg",
    //   activeSvg: "./images/stratum/dashboardLogoColored.svg",
    //   col: 1,
    //   link: "",
    // },
    {
      id: 2,
      svg: `${IMAGE_PATH}fileLogoSimple.svg`,
      activeSvg: `${IMAGE_PATH}filelLogoColored.svg`,
      col: 1,
      link: "/rfqs",
      name: "ALL RFQs",
    },
    {
      id: 3,
      svg: `${IMAGE_PATH}fileClickLogoSimple.svg`,
      activeSvg: `${IMAGE_PATH}fileClickLogoColored.svg`,
      col: 1,
      link: "/submittedqoutes",
      name: "Submitted Quote",
    },
    {
      id: 4,
      svg: `${IMAGE_PATH}ListLogoSimple.svg`,
      activeSvg: `${IMAGE_PATH}listLogoColored.svg`,
      col: 1,
      link: "/purchaseorder",
      name: "Purchase Order",
    },
    {
      id: 5,
      svg: `${IMAGE_PATH}halfListLogoSimple.svg`,
      activeSvg: `${IMAGE_PATH}halfListLOgoColored.svg`,
      col: 1,
      link: "/billspayment",
      name: "Bills & Payments",
    },
    {
      id: 6,
      svg: `${IMAGE_PATH}profileLogoSimple.svg`,
      activeSvg: `${IMAGE_PATH}profileLogoColored.svg`,
      col: 2,
      link: "/profile",
      name: "Profile",
    },
    {
      id: 7,
      svg: `${IMAGE_PATH}logoutLogoSimple.svg`,
      activeSvg: `${IMAGE_PATH}logoutLogoColored.svg`,
      col: 2,
      link: "/login",
      name: "Logout",
    },
  ];
  const [activeTabId, setActiveTab] = useState(active || sidebarArray[0].id);
  const dispatch = useDispatch();
  const onClickTabItem = (tabId) => {
    setActiveTab(tabId);
  };
  useEffect(() => {
    setActiveTab(active);
  }, [active]);

  const handleActiveTab = () => {};
  return (
    <div className="sidebarMainDiv">
      <div className="sidebarTopDiv">
        <div className="sidebarTopDivTop">
          <Link to={"/"}>
            {" "}
            <img
              src={SUB_LOGO}
              alt="logo"
              className="sideBarImg"
              onClick={handleActiveTab}
            />
          </Link>
        </div>
        <div className="sidebarTopDivBottom">
          {sidebarArray
            .filter((e) => e.col == 1)
            .map((e, i) => {
              return (
                <Tooltip
                  key={i}
                  content={e.name}
                  position={Position.RIGHT}
                  color="SUCCESS"
                  style={{ background: "red" }}
                >
                  <div
                    key={i}
                    onClick={() => {
                      // localStorage.setItem("active_Tab", JSON.stringify(e.id));
                      dispatch(set_active_tab(e.id));
                      onClickTabItem(e.id);
                      navigate(e.link);
                    }}
                    // to={ tab.link}
                    className={
                      activeTabId === e.id ? "activetab" : "inactivetab"
                    }
                  >
                    <Link to={e.link}>
                      <img src={activeTabId === e.id ? e.activeSvg : e.svg} />
                    </Link>
                  </div>
                </Tooltip>
              );
            })}
        </div>
      </div>
      <div className="sidebarBottomDiv">
        <div className="hrlinemain">
          <p className="hrline"></p>
        </div>
        {sidebarArray
          .filter((e) => e.col == 2)
          .map((e, i) => {
            return (
              <Tooltip key={i} content={e.name} position={Position.RIGHT}>
                <div
                  key={i}
                  onClick={() => {
                    // localStorage.setItem("active_Tab", JSON.stringify(e.id));

                    if (e.id == 7) {
                      // localStorage.clear();
                      // dispatch(set_active_tab(2));
                      // navigate("/login");
                      // dispatch(logout());
                      onOpenModal();
                      dispatch(set_active_tab(2));
                    } else {
                      onClickTabItem(e.id);
                      navigate(e.link);
                      dispatch(set_active_tab(e.id));
                    }
                  }}
                  className={activeTabId === e.id ? "activetab" : "inactivetab"}
                >
                  <Link to={e.id == 7 ? "/login" : e.link}>
                    <img src={activeTabId === e.id ? e.activeSvg : e.svg} />
                  </Link>
                </div>
              </Tooltip>
            );
          })}
      </div>

      <ModalLogout
        data={"Are you sure you want to logout?"}
        open={open}
        onOpenModal={onOpenModal}
        onCloseModal={onCloseModal}
        handleDisablebtn={handleDisablebtn}
        handleSubmit={() => handleSubmit()}
      />
    </div>
  );
};

export default Sidebar;
